<template>
  <div class="deepseek-container">
    <el-container style="height: 100%;">
      <!-- 侧边栏 -->
      <el-aside width="220px" class="sidebar">
        <div class="logo" style="background-color: #007a37;"> 
          <img  src="../assets/Hs.png" alt="中国华西企业股份有限公司BIM中心">
        </div>
        <el-menu
          default-active="1"
          background-color="black"
          text-color="#fff"
          active-text-color="#409EFF">
          <el-menu-item index="1" class="el-menu-item-ai">
            <i class="el-icon-chat-dot-round"></i>
            <span>制度查询</span>
          </el-menu-item >
          <el-menu-item index="2" class="el-menu-item-ai">
            <i class="el-icon-collection"></i>
            <span>方案编写</span>
          </el-menu-item>
          <el-menu-item index="3" class="el-menu-item-ai">
            <i class="el-icon-collection"></i>
            <span>文案审查</span>
          </el-menu-item>
          <el-menu-item index="4" class="el-menu-item-ai">
            <i class="el-icon-collection"></i>
            <span>综合Ai</span>
          </el-menu-item>
        </el-menu>
      </el-aside>

      <!-- 主内容区 -->
      <el-main class="main-content">
        <div class="chat-container">
          <!-- 消息区域 -->
          <div class="message-area" ref="messageArea">
            <div v-for="(msg, index) in messages" :key="index" 
                 :class="['message', msg.type]">
              <div class="avatar">
                <img v-if="msg.type === 'ai'" src="../assets/H.png">
                <img v-else src="../assets/name.png">
              </div>
              <div class="content">
                <div class="text" v-html="msg.content"></div>
                <div class="time">{{ msg.time }}</div>
              </div>
            </div>
          </div>

          <!-- 输入区域 -->
          <div class="input-area">
            <el-input
              type="textarea"
              :rows="3"
              placeholder="输入您的问题..."
              v-model="inputMessage"
              @keyup.enter.native="sendMessage">
            </el-input>
            <div class="action-bar">
              <el-button type="primary" @click="sendMessage" style="width: 150px;">发送</el-button>
              <el-button style="width: 120px;">清除</el-button>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
export default {
  name: '中国华西企业股份有限公司BIM中心Chat',
  data() {
    return {
      messages: [
        {
          type: 'ai',
          content: '你好！我是中国华西企业股份有限公司BIM中心AI助手，有什么可以帮您的吗？',
          time: '10:30'
        }
      ],
      inputMessage: ''
    }
  },
  methods: {
    sendMessage() {
      if (!this.inputMessage.trim()) return;
      
      // 添加用户消息
      this.messages.push({
        type: 'user',
        content: this.inputMessage,
        time: new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
      });
      
      // 模拟AI回复
      setTimeout(() => {
        this.messages.push({
          type: 'ai',
          content: '我已收到您的消息，正在处理中...',
          time: new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
        });
        this.$nextTick(() => {
          this.$refs.messageArea.scrollTop = this.$refs.messageArea.scrollHeight;
        });
      }, 1000);
      
      
      this.$axios({
            url: this.apiurl +
                "CozeAPI/GetMessage?str=" + this.inputMessage
        }).then((res) => {
            if (res.status == 200) {
              let a = res.data.split('\\n').join('<br>')
              this.messages.push({
              type: 'ai',
              content: res.data.split('\\n').join('<br>'),
              time: new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
        });
            }
        }, (err) => {
        });
        this.inputMessage = '';
    }
  }
}
</script>

<style scoped>
.deepseek-container {
  height: 100%;
  background-color: #f5f5f5;
}

.sidebar {
  background-color: #000000;
  height: 100%;
}

.logo {
  width: 200px;
  padding: 10px;
  text-align: center;
}

.logo img {
  width: 100px;
}

.main-content {
  padding: 0;
  height: 100%;
}

.chat-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 0px;

}

.message-area {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  background-color: #fff;
  height: 60%;
}

.message {
  display: flex;
  margin-bottom: 20px;
}

.message.ai {
  flex-direction: row;
}

.message.user {
  flex-direction: row-reverse;
}

.avatar {
  width: 40px;
  height: 40px;
  margin: 0 15px;
}

.avatar img {
  width: 100%;
  border-radius: 50%;
}

.content {
  max-width: 60%;
}

.text {
  padding: 12px 16px;
  border-radius: 8px;
  line-height: 1.5;
  font-size: 21px; 
  text-align: justify;
}

.time {
  font-size: 19px; 
  color: #999;
  margin-top: 5px;
}

.ai .text {
  background-color: #f0f7ff;
  color: #000000;
}

.user .text {
  background-color: #409EFF;
  color: white;
}

.time {
  font-size: 17px;
  color: #999;
  margin-top: 5px;
}

.input-area {
  padding: 15px;
  background-color: #fff;
  border-top: 1px solid #eee;
}

.action-bar {
  margin-top: 10px;
  text-align: right;
}

.el-textarea__inner {
  font-size: 22px; /* 进一步增大输入框字体 */
  padding: 16px; /* 进一步增大输入框内边距 */
  width: 100%; /* 确保输入框宽度占满容器 */
  min-height: 150px; /* 增大输入框最小高度 */
}

.el-button {
  padding: 14px 24px; /* 增大按钮内边距 */
  font-size: 18px; /* 增大按钮字体 */
}

.el-menu-item-ai {
  padding: 0 20px; /* 增大侧边栏菜单项内边距 */
  font-size: 18px; /* 增大侧边栏菜单项字体 */
  width: 220px;
}
</style>